import React from 'react'

import Details from './Details'

const DetailsTab = props => {
  return <Details />
}

export default DetailsTab
